<template>
    <div class="pagination mb-xl">
        <button class="pagination__link iconlink" :disabled="page === 1" @click="page -= 1">
            <svg width="20" height="20" viewBox="0 0 20 20">
                <path
                    d="M7.050 9.293l-0.707 0.707 5.657 5.657 1.414-1.414-4.242-4.243 4.242-4.243-1.414-1.414z"
                ></path>
            </svg>
        </button>

        <a
            v-for="p in visiblePagination"
            :key="p"
            class="pagination__page"
            :class="{ 'pagination__page--current': p === page }"
            @click="page = p"
        >
            {{ p }}
        </a>

        <button class="pagination__link iconlink" :disabled="page >= totalPages" @click="page += 1">
            <svg width="20" height="20" viewBox="0 0 20 20">
                <path
                    d="M12.95 10.707l0.707-0.707-5.657-5.657-1.414 1.414 4.242 4.243-4.242 4.243 1.414 1.414 4.95-4.95z"
                ></path>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        set: {
            type: Array,
            default: () => []
        },

        subset: {
            type: Array,
            default: () => []
        },

        itemsPerPage: {
            type: Number,
            default: 10
        }
    },

    data() {
        return {
            page: 1
        };
    },

    computed: {
        totalPages() {
            return Math.ceil(this.set.length / this.itemsPerPage);
        },

        visiblePagination() {
            const visibleNumbers = 5;
            let start = 1;
            let end = this.totalPages;


            if (this.totalPages > visibleNumbers) {
                const padding = Math.floor((visibleNumbers - 1) / 2);
                start = Math.max(1, this.page - padding);
                end = Math.min(this.totalPages, this.page + padding);

                if (start === 1) {
                    end = visibleNumbers;
                } else if (end === this.totalPages) {
                    start = this.totalPages - visibleNumbers;
                }
            }

            const pages = [];

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        }
    },

    watch: {
        page: {
            handler() {
                this.update();
                this.$emit('page-change');
            }
        },

        set: {
            handler() {
                this.page = 1;
                this.update();
            },
            immediate: true
        }
    },

    methods: {
        update() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            this.$emit('update:subset', this.set.slice(start, end));
        }
    }
};
</script>

<style lang="scss" scoped>
.pagination__link {
    &[disabled] {
        background-color: transparent;
        border-color: #DDDDDD;

        svg {
            color: #DDDDDD;
        }
    }

    svg {
        fill: currentColor;
        color: white;
    }
}
</style>
